import { getLocale } from "../runtime";

const sv_getnotified = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Få en notis`
};

const getnotified = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_getnotified(inputs)
	return "getNotified";
};

export { getnotified as "getNotified" };